export default "__VITE_ASSET__DRRfcU39__"